import React from 'react'

export const renderTextByNodes = (text: string) =>
  text
    .split(' ')
    .filter((textNode) => textNode !== '')
    .map((node, key) => <span key={key}>{node}</span>)
